import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { ListItemIcon } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Balance from "./Dashboard/Balance";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LogoutIcon from "@mui/icons-material/Logout";

import HomeIcon from "@mui/icons-material/Home";
import PaymentsIcon from "@mui/icons-material/Payments";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import WalletIcon from "@mui/icons-material/Wallet";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Context/Auth/AuthContext";

const drawerWidth = "80vw";
// const navItems = ["Home", "About", "Contact"];

const navItems = [
   { icon: <HomeIcon />, text: "Home", link: "" },
   { icon: <PaymentsIcon />, text: "Treks", link: "treks" },
   { icon: <AccountBalanceWalletIcon />, text: "Deposit", link: "deposit" },
   { icon: <LocalAtmIcon />, text: "Withdraw", link: "withdraw" },
   // { icon: <MarkunreadIcon />, text: "Referral Code", link: "" },
   { icon: <WalletIcon />, text: "Wallet", link: "wallet" },
];

function Navbar(props) {
   const { window: windowProp } = props;
   const [mobileOpen, setMobileOpen] = React.useState(false);
   const navigate = useNavigate();
   const location = useLocation();
   const { userState } = useAuth();

   const [anchorEl, setAnchorEl] = React.useState(null);
   const open = Boolean(anchorEl);

   const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
   };

   const handleClose = () => {
      setAnchorEl(null);
   };

   const handleLogout = () => {
      localStorage.removeItem("authToken");
      global.window.location.reload();
      handleClose();
   };

   const handleDrawerToggle = () => {
      setMobileOpen((prevState) => !prevState);
   };

   const drawer = (
      <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
         <Typography variant="h5" sx={{ my: 2 }}>
            Audley Travels
         </Typography>
         <Divider />
         <Balance />
         <Divider />
         <List>
            {navItems.map((item, index) => (
               <ListItem key={index} disablePadding>
                  <ListItemButton
                     sx={{
                        color: "#1a1a1a",
                        mx: 1,
                        "&:hover": {
                           backgroundColor: "rgba(0,0,0,0.04)",
                        },
                        ...(location.pathname === "/main" && item.link === ""
                           ? {
                                backgroundColor: "rgba(0,0,0,0.08)",
                                fontWeight: "bold",
                             }
                           : item.link && location.pathname === "/main/" + item.link
                             ? {
                                  backgroundColor: "rgba(0,0,0,0.08)",
                                  fontWeight: "bold",
                               }
                             : {}),
                     }}
                     onClick={() => navigate(item.link)}
                  >
                     {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                     <ListItemText primary={item.text} />
                  </ListItemButton>
               </ListItem>
            ))}
         </List>
      </Box>
   );

   const container = windowProp !== undefined ? () => windowProp().document.body : undefined;

   return (
      <Box sx={{ display: "flex" }}>
         <CssBaseline />
         <AppBar
            component="nav"
            sx={{
               background: "transparent",
               backdropFilter: "blur(10px)",
               boxShadow: "none",
            }}
         >
            <Toolbar
               sx={{
                  justifyContent: "space-between",
               }}
            >
               <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ display: { sm: "none" }, color: "#1a1a1a" }}
               >
                  <MenuIcon />
               </IconButton>
               <Typography
                  variant="h6"
                  component="div"
                  sx={{
                     flexGrow: 1,
                     display: { xs: "block", sm: "block" },
                     color: "#1a1a1a",
                     textAlign: { xs: "center", sm: "left" },
                  }}
               >
                  Audley Travels
               </Typography>
               <Box sx={{ display: { xs: "none", sm: "block", marginInline: 15 } }}>
                  {navItems.map((item, index) => (
                     <Button
                        key={index}
                        sx={{
                           color: "#1a1a1a",
                           mx: 1,
                           "&:hover": {
                              backgroundColor: "rgba(0,0,0,0.04)",
                           },
                           ...(location.pathname === "/main" && item.link === ""
                              ? {
                                   backgroundColor: "rgba(0,0,0,0.08)",
                                   fontWeight: "bold",
                                }
                              : item.link && location.pathname === "/main/" + item.link
                                ? {
                                     backgroundColor: "rgba(0,0,0,0.08)",
                                     fontWeight: "bold",
                                  }
                                : {}),
                        }}
                        onClick={() => navigate(item.link)}
                     >
                        {item.text}
                     </Button>
                  ))}
               </Box>
               <IconButton
                  color="inherit"
                  aria-label="account settings"
                  edge="start"
                  onClick={handleClick}
                  sx={{ color: "#1a1a1a" }}
               >
                  <AccountCircleIcon />
               </IconButton>
               <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                     "aria-labelledby": "basic-button",
                  }}
                  sx={{
                     "& .MuiPaper-root": {
                        backgroundColor: "rgba(255, 255, 255, 0.3)", // Semi-transparent white background
                        backdropFilter: "blur(16px)", // Adds blur effect
                        borderRadius: "8px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                     },
                  }}
               >
                  <Typography
                     sx={{
                        textAlign: "center",
                        width: "200px",
                        fontSize: { xs: "1.25rem", sm: "1.5rem" },
                        fontWeight: "bold", // Bold font for user name
                        color: "#333", // Dark text color
                     }}
                  >
                     {userState.user.userName}
                  </Typography>
                  <Divider sx={{ borderColor: "#ddd", margin: "8px 0" }} />{" "}
                  {/* Light grey divider */}
                  <MenuItem
                     onClick={handleLogout}
                     sx={{
                        justifyContent: "start", // Align items to the start
                        color: "#333", // Dark text color
                        "&:hover": {
                           backgroundColor: "#f0f0f0", // Light grey background on hover
                        },
                     }}
                  >
                     <ListItemIcon sx={{ color: "#333" }}>
                        {" "}
                        {/* Dark icon color */}
                        <LogoutIcon fontSize="small" />
                     </ListItemIcon>
                     <Typography sx={{ fontWeight: "bold" }}>Logout</Typography>{" "}
                     {/* Bold text for menu item */}
                  </MenuItem>
               </Menu>
            </Toolbar>
         </AppBar>
         <nav>
            <Drawer
               container={container}
               variant="temporary"
               open={mobileOpen}
               onClose={handleDrawerToggle}
               ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
               }}
               sx={{
                  display: { xs: "block", sm: "none" },
                  "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
               }}
            >
               {drawer}
            </Drawer>
         </nav>
      </Box>
   );
}

Navbar.propTypes = {
   /**
    * Injected by the documentation to work in an iframe.
    * You won't need it on your project.
    */
   window: PropTypes.func,
};

export default Navbar;
